import type { WelcomePost } from '../types'

export const getCommonWelcomePostPayload = (welcomePost: WelcomePost) => {
  return {
    core: {
      title: welcomePost.title,
      description: welcomePost.description || '',
    },
  }
}
